import { isDevMode } from '@angular/core';
import {
  ActionReducerMap,
  MetaReducer
} from '@ngrx/store';
import { userReducer } from './user.reducer';
import { 
  careerGoalReducer, 
  careerMatchesReducer, 
  createAdeptIDCareerReducer, 
  createCareerFilterReducer 
} from './careers.reducer';
import { 
  surveyQuestionsReducer, 
  surveyReducer, 
  surveyResponseReducer, 
  riasecScoreReducer 
} from './surveys.reducer';
import { resumeReducer } from './resume.reducer';
import { userBiqReducer } from './biq.reducer';
import { Survey, SurveyQuestion, SurveyResponse } from '@app/schemas/surveys';
import { FilterFormDataSchema } from '@app/schemas/career-matches';
import { adaptIDJobPostingReducer, generatedJobIdsReducer, jobFilterReducer, jobListReducer, jobSortByReducer, jobUserContextReducer } from './jobs.reducer';
import { AdaptIDJobPostingSchema, JobListSchema, JobUserContextSchema } from '@app/schemas/jobs';
import { globalLoaderReducer } from './global.reducer';

export interface State {
  survey: Survey | {};
  user: any;
  careerMatches: any;
  resumeDetails: any;
  surveyQuestions: SurveyQuestion[];
  userResponse: SurveyResponse[];
  careerGoal: any;
  userBiq: any;
  riasecScore: any;
  careerFilter: FilterFormDataSchema;
  adeptIDCareers: any;
  jobList: JobListSchema[];
  jobFilter: {
    role: string[];
    location: string[];
    education: string;
    is_bookmarked: boolean;
    is_related_to_career_goal: boolean;
  };
  adaptIdJobList: AdaptIDJobPostingSchema[];
  jobSortedBy: string;
  globalLoader: boolean;
  jobUserContext: JobUserContextSchema | {};
  generatedJobIds: string[];
}

export const reducers: ActionReducerMap<State> = {
  survey: surveyReducer,
  user: userReducer,
  careerMatches: careerMatchesReducer,
  resumeDetails: resumeReducer,
  surveyQuestions: surveyQuestionsReducer,
  userResponse: surveyResponseReducer,
  careerGoal: careerGoalReducer,
  userBiq: userBiqReducer,
  riasecScore: riasecScoreReducer,
  careerFilter: createCareerFilterReducer,
  adeptIDCareers: createAdeptIDCareerReducer,
  jobList: jobListReducer,
  jobFilter: jobFilterReducer,
  adaptIdJobList: adaptIDJobPostingReducer,
  jobSortedBy: jobSortByReducer,
  globalLoader: globalLoaderReducer,
  jobUserContext: jobUserContextReducer,
  generatedJobIds: generatedJobIdsReducer,
};


export const metaReducers: MetaReducer<State>[] = isDevMode() ? [] : [];
